var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "lightbox-popup": true,
        mobile: _vm.isMobileView
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.closePopup($event)
        }
      }
    },
    [
      _c("div", { staticClass: "light-box-center" }, [
        _c("div", { class: { container: true, "h-100": _vm.center } }, [
          _c("div", { class: { row: true, "h-100": _vm.center } }, [
            _c(
              "div",
              {
                staticClass: "col",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [_vm._t("light-box-content")],
              2
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f3fda18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f3fda18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/display/Lightbox.vue
// module id = null
// module chunks = 